export function queryOrderDataNoAuth(objectId: string | undefined) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/orders/by-object-id/${objectId}/no-auth`,
  }
}
